import { gql } from "../__generated__";

export const GetPlaceById = gql(`
  query GetPlaceById(
    $where: OrtWhereUniqueInput!
    $hydrateRelationships: Boolean!
  ) {
    place: ort(where: $where) {
      name
      id
      description {
        document(hydrateRelationships: $hydrateRelationships)
      }
      typen {
        id
      }
      images {
        images {
          bild {
            url
            id
          }
          objekte {
            title
            id
            description {
              document(
                hydrateRelationships: $hydrateRelationships
              )
            }
            copyright {
              name
            }
            images {
              title
              name
            }
            periodOfOrigin {
              displayName
            }
            authorPerson {
              familyName
              givenName
              id
            }
            authorGroup {
              id
              bezeichnung
            }
            personsOnWork {
              familyName
              givenName
              id
            }
            groupsOnWork {
              id
              bezeichnung
            }
            locationOnWork {
              id
              name
            }
          }
        }
      }
      address
      nativeNames
      area {
        name
        teilVon {
          name
        }
      }
      gps
      personenPlaceOfBirth {
        familyName
        givenName
        id
      }
      weblinks {
        document
      }
      objectPlace {
        id
        title
      }
      objectLocationOnWork {
        id
        title
      }
      objectLocationToday {
        id
        title
      }
      eventPlace {
        id
        title
      }
      eventLocationOnEvent {
        id
        title
      }
      groupPlaces {
        id
        bezeichnung
      }
    }
  }
`);

export const GetPlaces = gql(`
  query GetPlaces($take: Int, $skip: Int, $where: OrtWhereInput, $hydrateRelationships: Boolean!) {
    count: ortsCount(where: $where)
    items: orts(take: $take, skip: $skip, where: $where) {
      id
      name
      gps
      address
      area {
        name
      }
      typen {
        id
        name
      }
      images {
        images {
          displayName
          bild {
            url
            id
          }
        }
      }
      nativeNames
      description {
        document(hydrateRelationships: $hydrateRelationships)
      }
    }
  }
`);

export const GetPlaceProperties = gql(`
  query GetPlaceProperties($take: Int, $where: OrtsEigenschaftWhereInput) {
    items: ortsEigenschafts(take: $take, where: $where) {
      id
      name
    }
  }
`);
